// extracted by mini-css-extract-plugin
export default {"Container":"Tabs_Container__LwwGI","Tab":"Tabs_Tab__j7KC+","Inactive":"Tabs_Inactive__q0zb1","Active":"Tabs_Active__Cdpgc"};